import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const FilterIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 13" },
        React.createElement("path", { d: "M1.08709 0H14.8502C15.276 0 15.5069 0.49825 15.2317 0.82316L10.2369 6.72027C10.0839 6.90088 9.99998 7.1299 9.99998 7.36659V11.6841C9.99998 11.8838 9.88637 12.0633 9.70327 12.143C9.34123 12.3008 8.82262 12.4674 8.18596 12.4951C7.37055 12.5306 6.71189 12.3229 6.29421 12.1414C6.11178 12.0621 5.99999 11.8826 5.99999 11.6837V7.36993C5.99999 7.13122 5.9146 6.90038 5.75925 6.71914L0.707457 0.8254C0.429457 0.50106 0.659907 0 1.08709 0Z" })));
};

export { FilterIcon };
//# sourceMappingURL=FilterIcon.esm.js.map
